import { useState } from "react";
import { FaDownload, FaPrint } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import ConfirmPopUp from "./QiwaContractTab/ConfirmPopup/ConfirmPopup";

export default function QiwaPopUp({ data, PopUp, setPopUp, updateApi,isGrTrue }) {
  const apiCall = () => {
    setPopUp(false);
    updateApi();
  };
  const contentRef = useRef(null);
  const [yesPopup, setYesPopup] = useState(false);

  const convertToPdf = () => {
    const content = contentRef.current;
    const options = {
      filename: "Qiwa_contract.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .set(options)
      .from(content)
      .toPdf()
      .save()
      .catch((error) => console.log(error));
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${PopUp ? "flex" : "hidden"
          }`}
      >
        <div className="max-w max-h-[35rem]  rounded-md bg-white/95  overflow-scroll  flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
            <div className="flex absolute gap-x-2 top-2 right-4 font-semibold">
              <button
                className="flex text-white bg-red items-center gap-x-2 py-1 px-2"
                onClick={() => convertToPdf()}
              >
                <FaDownload fontSize={12} />
                <p className="bg-red text-white">DOWNLOAD</p>
              </button>
              <button
                className="flex text-white bg-red items-center gap-x-2 py-1 px-2"
                onClick={() => print()}
              >
                <FaPrint fontSize={12} />
                <p className="bg-red text-white">PRINT</p>
              </button>
            </div>
          </div>
          <div
            className="flex gap-3 w-full justify-center flex-col my-3 p-5"
            style={{ margin: 2 }}
          >
            <div>
              {/* firstcol */}
              <div ref={contentRef} className="flex flex-row p-5">
                <div className="border-r-2 px-1 text-gray flex flex-col gap-y-3 text-sm pr-5 w-auto mr-10">
                  <div>
                    <p>EMPLOYEE NAME</p>
                    <p className="font-bold">{data.employee_name || "-"}</p>
                  </div>
                  <div>
                    <p>IQAMA PROFESSION ENGLISH</p>
                    <p className="font-bold">
                      {data.iqama_expiry_date_hijri || "-"}
                    </p>
                  </div>
                  <div>
                    <p>EMPLOYEE PHONE NUMBER</p>
                    <p className="font-bold">
                      {data.emp_ksa_contact_number || "-"}
                    </p>
                  </div>
                  <div>
                    <p>CURRENT SPONSER</p>
                    <p className="font-bold">{data.current_sponsor || "-"}</p>
                  </div>
                  <div>
                    <p>DATE OF BIRTH</p>
                    <p className="font-bold">{data.dob || "-"}</p>
                  </div>
                  <div>
                    <p>WORKINH HOURS(PER DAY)</p>
                    <p className="font-bold">{data.duty_hours || "-"}</p>
                  </div>
                  <div>
                    <p>EMPLOYEE ID</p>
                    <p className="font-bold">{data.employee_id || "-"}</p>
                  </div>
                  <div>
                    <p>IQAMA EXPIRY DATE HIJRI</p>
                    <p className="font-bold">{data.iqama_expiry || "-"}</p>
                  </div>
                  <div>
                    <p>CONTRACT START DATE</p>
                    <p className="font-bold">{data.ksa_arrival_date || "-"}</p>
                  </div>
                  <div>
                    <p>PROBATION PERIOD</p>
                    <p className="font-bold">{data.probation_period || "-"}</p>
                  </div>
                  <div>
                    <p>BASIC SALARY</p>
                    <p className="font-bold">
                      {data.client_basic_salary || "-"}
                    </p>
                  </div>
                  <div>
                    <p>FOOD</p>
                    <p className="font-bold">{data.food_allowance1 || "-"}</p>
                  </div>
                  <div>
                    <p>MEDICAL INSURANCE</p>
                    <p className="font-bold">{data.medical_status || "-"}</p>
                  </div>
                  <div>
                    <p>STATUS</p>
                    <p className="font-bold">{data.nakala_status || "-"}</p>
                  </div>
                </div>
                {/* secondcol */}
                <>
                  <div>
                    <div className="border-r-2 px-1 text-gray flex flex-col gap-y-3 text-sm pr-5 w-auto mr-10 mb-10">
                      <div className="">
                        <p>IQAMA NUMBER</p>
                        <p className="font-bold">{data.iqama_number || "-"}</p>
                      </div>

                      <div>
                        <p className="pb-2">EMPLOYEE EMAIL ID</p>
                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>

                      <div>
                        <div className="pb-2">
                          <p className="text-sm">OPTIONAL CONDITION</p>
                          <br />
                          SHOULD NOT COMPLETE WITH OUR BUSINESS FOR 2 YEARS
                          <br /> MENTION-(REQUIRED /NOT REQUIRED)
                        </div>

                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>

                      <div>
                        <p className="pb-2">
                          CONTRACT RENEWAL <br />
                          (AUTOMATIC RENEWAL / TERMINATE ON EXPIRY DATE)
                        </p>

                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>

                      <div>
                        <p className="pb-2">
                          OPTIONAL 1/2
                          <br />
                          IF COMPANY REMOVES LABOR-COMPANY HAS TO PAY THE
                          EMPLOYEE
                          <br /> MENTION-(AMOUNT /NOT REQUIRED)
                        </p>
                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>

                      <div>
                        <p className="pb-2">
                          TRANSPORTATION <br />
                          (AMOUNT / BY COMPANY / DONT MENTION ANYTHING)
                        </p>

                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>
                      <div>
                        <p className="pb-2">NO. OF WORK DAYS IN A WEEK</p>

                        <input
                          disabled={true}
                          type="text"
                          className="input input-sm input-bordered"
                        />
                      </div>
                    </div>

                    {/* <div className="text-2xl gap-10 flex">
                      <p> Update the details in qiwa website</p>
                      <button
                        className="p-2 px-4  bg-green-500 disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                        onClick={() => setYesPopup(true)}
                      >
                        <p>YES</p>
                      </button>
                    </div> */}

                    <>
                      {data.statusData == "Pending Employee Approval" ? (
                        <div className="text-2xl gap-10 flex">
                          Update the details in qiwa website
                          <button
                            className="p-2 px-4  bg-green-500 disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                            onClick={() => setYesPopup(true)}
                          >
                            <p>YES</p>
                          </button>
                        </div>
                      ) : (
                        <div className="text-2xl gap-10 flex">
                          Uploaded the details in QIWA WEBSITE ? 
                          <button
                            className="p-2 px-4  bg-green-500 disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                            onClick={() => setYesPopup(true)}
                          >
                            <p>YES</p>
                          </button>
                        </div>
                      )}
                    </>
                  </div>

                  {/* thirdcol */}
                  <div className=" px-1 text-gray flex flex-col gap-y-3 text-sm pr-5 w-auto mr-10">
                    <div>
                      <p>CONTRACT PERIOD (MONTHS)</p>
                      <p className="font-bold">POPULATE</p>
                    </div>

                    <div>
                      <p className="pb-2">IQAMA PROFESSION ARABIC</p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>

                    <div className="pt-2">
                      <p>OPTIONAL CONDITION</p>
                      <p className="pb-2">
                        SHOULD NOT COMPLETE WITH OUR BUSINESS FOR 2 YEARS
                        <br /> MENTION-(REQUIRED /NOT REQUIRED)
                      </p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>

                    <div>
                      <p>OTHER ALLOWANCE PER MONTH IF YOU WANT TO ADD</p>
                      <p className="pb-2">NAME OF THE ALLOWANCE AND AMOUNT</p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>

                    <div>
                      <p>OPTIONAL 2/2</p>
                      <p className="pb-2">
                        IF LABOR WANTS TO TERMINATE THE CONTRACT-
                        <br />
                        LABOR HAS TO PAY THE COMPANY MENTION- (AMOUNT/NOT
                        REQUIRED)
                      </p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>

                    <div>
                      <p>NO OF ANNUAL VACATION DAYS</p>
                      <p className="pb-2">
                        (AMOUNT / BY COMPANY / DONT MENTION ANYTHING){" "}
                      </p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>
                    <div>
                      <p>HOUSING</p>
                      <p className="pb-2">
                        (AMOUNT / BY COMPANY / DONT MENTION ANYTHING)
                      </p>
                      <input
                        disabled={true}
                        type="text"
                        className="input input-sm input-bordered"
                      />
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
      {yesPopup === true ? (
        <ConfirmPopUp
          PopUp={yesPopup}
          setYesPopup={setYesPopup}
          title={"This action will change this status to"}
          url={"/qiwaContract/status"}
          callBack={apiCall}
          dataEmp={data}
        />
      ) : (
        ""
      )}
    </>
  );
}
